import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FiscalBenefitContextValue {
  hasFiscalBenefit: boolean;
  setHasFiscalBenefit: (value: boolean) => void;
}

const FiscalBenefitContext = createContext<
  FiscalBenefitContextValue | undefined
>(undefined);

export const FiscalBenefitProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [hasFiscalBenefit, setHasFiscalBenefit] = useState<boolean>(false);

  return (
    <FiscalBenefitContext.Provider
      value={{ hasFiscalBenefit, setHasFiscalBenefit }}
    >
      {children}
    </FiscalBenefitContext.Provider>
  );
};

export const useFiscalBenefit = (): FiscalBenefitContextValue => {
  const context = useContext(FiscalBenefitContext);
  if (!context) {
    throw new Error(
      'useFiscalBenefit must be used within a FiscalBenefitProvider'
    );
  }
  return context;
};
